
import { defineComponent } from 'vue'
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
export default defineComponent({
  name: 'HomepageTwitterNew',
  props: {
    block: {
      type: Object,
      required: true,
    },
  },
  data(){
    return {
      carouselSettingsControll: {
        arrows: false,
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        draggable: false,
        speed: 850,
        cssEase: 'linear',
        pauseOnHover: true,
        lazyLoad: "progressive",
        variableWidth: true,
        touchMove: false,
      },
      pressedArrow: '',
    }
  },
  methods: {
      showNext() {
        this.pressedArrow = 'next';
        (this.$refs.carousel as VueSlickCarousel).next();
        (this.$refs.carousel as VueSlickCarousel).pause();
      },

      showPrev() {
        this.pressedArrow = 'prev';
        (this.$refs.carousel as VueSlickCarousel).prev();
        (this.$refs.carousel as VueSlickCarousel).pause();
      },

      beforeChange( oldSlideIndex, newSlideIndex ) {
        this.removeAnimationClasses();

        if( this.pressedArrow === 'next' ){
          const correspondingSlides = document.querySelectorAll(`.slide_${oldSlideIndex}`);

          correspondingSlides.forEach(slide => {
              if (slide.closest('.slick-current')) {
                slide.classList.add('exiting-class');
              }
          });
        }
        else if( this.pressedArrow === 'prev' ){
          const correspondingSlides = document.querySelectorAll(`.slide_${newSlideIndex }`);

          correspondingSlides.forEach(slide => {
              if (slide.closest('.slick-slide')?.nextElementSibling?.classList.contains('slick-current')) {
                slide.classList.add('entering-class');
              }
          });
        }
      },

      removeAnimationClasses(){
        const allSlides = document.querySelectorAll('.tweet');

        allSlides.forEach(slide => {
            slide.classList.remove('exiting-class','entering-class' );
          })
      }
    },
  components: { VueSlickCarousel },
})
